import { Component } from "@angular/core";
import { Subscription } from "rxjs";
import { PaginationParams } from "src/app/shared/models/common";
import {
  DrProfile,
  DrProfileSearchParams,
} from "src/app/shared/models/order.model";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { ServiceMetaData } from "src/app/shared/models/service-meta.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { DrProfileListComponent } from "./dr-profile-list/dr-profile-list.component";
import { Store } from "@ngrx/store";
import {
  drProfiles,
  drProfilesSearchMetadata,
} from "src/app/shared/ngrx/ngrx-selectors";
import { RUN_DR_PROFILES_SEARCH } from "src/app/shared/ngrx/ngrx-actions";
import { DrProfileFiltersComponent } from "./dr-profile-filters/dr-profile-filters.component";
import { ModalPopupComponent } from "src/app/shared/components/ui/modal-popup.component";
import { EditDrProfileWizardComponent } from "./edit-dr-profile-wizard/edit-dr-profile-wizard.component";
import { LoaderComponent } from "src/app/shared/components/ui/loader/loader.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { CreateDrProfileComponent } from "./create-dr-profile/create-dr-profile.component";

@Component({
  selector: "app-mng-dr-profile",
  templateUrl: "./mng-dr-profile.component.html",
  styleUrls: ["./mng-dr-profile.component.scss"],
  imports: [
    DrProfileListComponent,
    DrProfileFiltersComponent,
    ModalPopupComponent,
    EditDrProfileWizardComponent,
    LoaderComponent,
    TranslateModule,
    CommonModule,
    CreateDrProfileComponent,
  ],
  standalone: true,
})
export class MngDrProfileComponent {
  loading: boolean;
  searchSubscription: Subscription;
  routeEnum: RouteEnum = new RouteEnum();
  numberOfRows: number = 20;
  rangeFrom: number = 1;
  rangeTo: number = this.numberOfRows;
  totalRecords: number;
  editRow: DrProfile;
  editProfileDisplay: boolean;
  createProfileDisplay: boolean;

  get searchMetaData(): ServiceMetaData {
    return this.store.selectSignal(drProfilesSearchMetadata)() || {};
  }

  get data(): DrProfile[] {
    return this.store.selectSignal(drProfiles)();
  }

  searchParams: DrProfileSearchParams = {
    rangeTo: this.rangeTo,
    rangeFrom: this.rangeFrom,
    searchId: null,
  };

  constructor(
    private readonly store: Store,
    private broshService: BroshService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.search(true);
  }

  ngOnDestroy(): void {}

  loadDataOnPagination(event: any) {
    if (
      !this.data ||
      (event.rangeFrom == this.searchParams.rangeFrom &&
        event.rangeTo == this.searchParams.rangeTo)
    )
      return;

    this.searchParams.rangeFrom = event.rangeFrom;
    this.searchParams.rangeTo = event.rangeTo;
    this.searchParams.searchId = this.store.selectSignal(
      drProfilesSearchMetadata
    )().searchId;

    this.search(false);
  }

  getProfilesBySearch(params: DrProfileSearchParams) {
    console.log(params);
    this.searchParams = Object.assign(
      this.searchParams,
      this.store.selectSignal(drProfilesSearchMetadata)(),
      params
    );

    this.searchParams.rangeFrom = 1;
    this.searchParams.rangeTo = this.numberOfRows;
    this.searchParams.searchId = null;

    this.search(true);
  }

  search(newSearch: boolean) {
    this.loading = true;

    var element = document.getElementById("profileSearch");
    if (element) element.scrollIntoView(true);

    this.store.dispatch(
      RUN_DR_PROFILES_SEARCH({
        newSearch: newSearch,
      })
    );
    this.broshService.getDrProfiles(this.searchParams).subscribe(
      () => {
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  edit(row: DrProfile) {
    this.editRow = row;
    this.editProfileDisplay = true;
  }

  onCreateClicked() {
    this.createProfileDisplay = true;
  }

  onCreateProfileClosed(profile: DrProfile) {
    this.createProfileDisplay = false;

    if (profile) {
      profile.createMode = true;
      this.edit(profile);
    }
  }

  onSave() {
    this.editProfileDisplay = false;
    this.search(true);
  }
}
